// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__RKf7A","inputDescription":"styles_inputDescription__28O8U"};